import { render, staticRenderFns } from "./SemesterDetails.vue?vue&type=template&id=6bab775a"
import script from "./SemesterDetails.vue?vue&type=script&lang=js"
export * from "./SemesterDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports